import {FEEDBACK_SENTIMENT} from './mockData';

export const formatMoney = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  return num % 1 === 0 ? String(num) : num.toFixed(2);
};

export const buildPromoSentence = (discount, sentiment) => {
  if (!discount) return null;
  const code = discount.promoCode?.code;
  const valueStr = formatMoney(discount.rate?.value);
  const minStr = formatMoney(discount.subtotal?.min);
  if (!code || valueStr === '') return null;
  const off =
    discount.rate?.type === 'Percentage' ? `${valueStr}%` : `$${valueStr}`;
  const min = minStr === '' || Number(minStr) === 0 ? '' : ` (min $${minStr})`;
  if (sentiment === FEEDBACK_SENTIMENT.POSITIVE) {
    return `As a thank you, use code ${code} for ${off} off your next order${min}.`;
  }
  return `We'd like to make it up to you. Please use code ${code} for ${off} off your next order${min}, on us.`;
};
